var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.dnsFormatted},scopedSlots:_vm._u([{key:"cell(action)",fn:function(row){return [_c('DeleteDnsIcon',{staticClass:"float-right",attrs:{"dns":row.item.dns}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }